import React from 'react';
import { AlertCircle } from 'lucide-react';
interface DigitalDisclaimerProps {
  /** Use 'light' on dark/green backgrounds, 'dark' on light backgrounds */
  variant?: 'light' | 'dark';
  className?: string;
}
export function DigitalDisclaimer({
  variant = 'dark',
  className = ''
}: DigitalDisclaimerProps) {
  const isLight = variant === 'light';
  return <p className={`flex items-start gap-2 text-[11px] sm:text-xs leading-relaxed max-w-md mx-auto mt-4 ${isLight ? 'text-white/55' : 'text-brand-text/55'} ${className}`} data-id="element-149">
      <AlertCircle className={`w-3.5 h-3.5 flex-shrink-0 mt-0.5 ${isLight ? 'text-brand-gold' : 'text-brand-green'}`} strokeWidth={2} data-id="element-150" />
      <span data-id="element-151">
        <span className="font-semibold" data-id="element-152">Importante:</span> Este producto es 100%
        digital y de acceso inmediato. Debido a la naturaleza descargable del
        contenido, no se realizan devoluciones ni reembolsos una vez completada
        la compra.
      </span>
    </p>;
}